module.exports = __webpack_public_path__ + "img/gal_1.91ca0862.png";